<template>
    <div class="cart">
        <!--Top Bar-->
        <TopBar msg="Welcome to Your Vue.js App" />
        <!--Top Bar-->

        <v-divider></v-divider>

        <v-card elevation="0"
            class="bg-secondary mx-auto rounded-xl mt-n6 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none "
            height="120">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="mobile-category-title-text">
                    Checkout
                </h1>
            </div>
        </v-card>

        <v-container>
            <v-row dense class="bg-white">
                <v-col cols="12" sm="12" md="12">
                    <v-card class="mx-auto bg-white" elevation="0" min-height="500" max-width="1100">
                        <div class="d-flex flex-column text-left text-black ml-2">
                            <h1
                                class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block  font-weight-bold mt-4 ml-4">
                                ORDER CONFIRM
                            </h1>
                        </div>

                        <v-row dense>
                            <v-col cols="12" sm="7" md="7">
                                <!--alert box-->
                                <v-alert type="success" v-if="orderStatus" class="mt-10  text-left" border color="primary">

                                    <div v-for="(resp, i) in getOrderResponse" :key="i" class="text-white">
                                        {{ resp }}
                                    </div>
                                </v-alert>

                                <v-card class="ma-4 rounded-xl pa-5" elevation="0" variant="outlined" dark
                                    v-if="orderStatus == false">
                                    <div class="text-right">
                                        <v-btn class="ma-2" color="primary" @click="addressDialog = true"
                                            variant="outlined">
                                            <v-icon color="primary" size="25">mdi-account-edit</v-icon>
                                        </v-btn>
                                    </div>

                                    <form class="mt-5">

                                        <v-text-field v-model="getAddress.name" label="Name" variant="outlined"
                                            color="black" type="text" class="mb-2" disabled></v-text-field>

                                        <v-text-field v-model="getAddress.mobileno" label="Mobileno" variant="outlined"
                                            color="black" type="number" class="mb-2" disabled></v-text-field>

                                        <v-text-field v-model="getAddress.flat_door_no" label="Flat / Address No"
                                            variant="outlined" color="black" type="text" class="mb-2"
                                            disabled></v-text-field>

                                        <v-text-field v-model="getAddress.address" label="Address" variant="outlined"
                                            color="black" type="text" class="mb-2" disabled></v-text-field>

                                        <v-text-field v-model="getAddress.pincode" label="Pincode" variant="outlined"
                                            color="black" type="text" class="mb-2" disabled></v-text-field>

                                        <v-btn class="text-none text-subtitle-2 font-weight-bold mb-5 cart-btn float-left"
                                            color="primary" rounded variant="flat" width="220"
                                            @click="orderConfirmDialog = true">
                                            <p class="text-white">ORDER CONFIRM</p>
                                        </v-btn>

                                    </form>
                                </v-card>
                            </v-col>
                        </v-row>

                    </v-card>
                </v-col>

            </v-row>
        </v-container>

        <v-dialog width="500" v-model="addressDialog" class="rounded-xl" persistent height="auto">
            <v-card color="white" class="ma-5 pa-5 text-center">
                <v-card-title class="text-h5 mb-3">
                    Address Update
                </v-card-title>

                <!--alert box-->
                <v-alert type="success" v-if="addressStatusmsg" class="mb-5 text-left" border color="primary">
                    <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                        {{ addressStatusResponse }}
                    </div>

                    <div class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                        {{ addressStatusResponse }}
                    </div>
                </v-alert>
                <div v-if="addressErrorStatusmsg" class="mb-5">
                    <v-alert type="error" v-for="(resp, i) in addressStatusResponse" :key="i" class="mb-1 text-left" border>
                        <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                            {{ resp }}
                        </div>

                        <div class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                            {{ resp }}
                        </div>
                    </v-alert>
                </div>

                <!--alert box end-->


                <v-text-field v-model="name" :error-messages="v$.name.$errors.map(e => e.$message)" label="Name*" required
                    @input="v$.name.$touch" @blur="v$.name.$touch" variant="outlined" color="black" class="mb-2"
                    type="text"></v-text-field>

                <v-text-field v-model="flat_door_no" :error-messages="v$.flat_door_no.$errors.map(e => e.$message)"
                    label="Flat / Door No*" required @input="v$.flat_door_no.$touch" @blur="v$.flat_door_no.$touch"
                    variant="outlined" color="black" class="mb-2"></v-text-field>


                <v-text-field v-model="address" :error-messages="v$.address.$errors.map(e => e.$message)" label="Address*"
                    required @input="v$.address.$touch" @blur="v$.address.$touch" variant="outlined" color="black"
                    class="mb-2"></v-text-field>

                <v-text-field v-model="pincode" :error-messages="v$.pincode.$errors.map(e => e.$message)" label="Pincode*"
                    required @input="v$.pincode.$touch" @blur="v$.pincode.$touch" variant="outlined" color="black"
                    class="mb-2"></v-text-field>

                <v-divider></v-divider>

                <v-card-actions class="mt-3 text-center justify-left">
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="primary" variant="flat"
                        rounded @click="addressFormUpdate" width="120">
                        <p class="text-white">UPDATE</p>
                    </v-btn>
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat"
                        rounded @click="addressDialog = false" width="100">
                        CLOSE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog width="500" v-model="orderConfirmDialog" class="rounded-xl" persistent>
            <v-card color="white" class="ma-5 pa-5 text-center">
                <v-card-title class="text-h5">
                    Order Confirm?
                </v-card-title>

                <v-card-actions class="mt-3 text-center justify-center">
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="primary" variant="flat"
                        rounded @click="confirm" width="120">
                        <p class="text-white">CONFIRM</p>
                    </v-btn>
                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat"
                        rounded @click="orderConfirmDialog = false" width="100">
                        CLOSE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <AppFooter />

    </div>
</template>
  


<style>
.cart-btn {
    letter-spacing: 0px !important;
    font-size: 14px !important;
    height: 48px !important;
}

.alert-text {
    font-size: 13px !important;
}
</style>

<script >
// @ is an alias to /src

import TopBar from '@/components/Bar.vue'

import AppFooter from '@/components/Footer.vue'

import { useVuelidate } from '@vuelidate/core'
import { required, numeric, minLength, maxLength, helpers } from '@vuelidate/validators'

import { mapActions, mapGetters } from "vuex";
export default {
    name: 'CheckoutView',
    setup: () => ({ v$: useVuelidate() }),
    data: () => ({
        orderConfirmDialog: false,
        addressDialog: false,
    }),
    validations() {
        return {
            name: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            flat_door_no: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            address: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            pincode: {
                required: helpers.withMessage('This field cannot be empty', required),
                numeric,
                minLength: minLength(6),
                maxLength: maxLength(6),
            },

        }
    },
    components: {
        TopBar,
        AppFooter,

    },
    created() {
        this.addressDetails();
        this.getlocationDetails();
        this.$store.subscribe((mutation) => {
            if (mutation.type === "orderSuccessResponse") {
                this.orderConfirmDialog = false;
            }
        });
    },
    computed: {
        ...mapGetters([
            "getAddress",
            "getOrderStatus",
            "getOrderResponse",
            "getAddressStatus",
            "getAddressResponse",
            "locationDetails",
        ]),
        addressStatusmsg: function () {
            return this.getAddressStatus === "success";
        },
        addressErrorStatusmsg: function () {
            return this.getAddressStatus === "error";
        },
        addressStatusResponse: function () {
            return this.getAddressResponse;
        },
        name: {
            get() {
                return this.getAddress.name;
            },
            set(value) {
                this.$store.commit("updateCustomerName", value);
            }
        },
        flat_door_no: {
            get() {
                return this.getAddress.flat_door_no;
            },
            set(value) {
                this.$store.commit("updateCustomerFlat", value);
            }
        },
        address: {
            get() {
                return this.getAddress.address;
            },
            set(value) {
                this.$store.commit("updateCustomerAddress", value);
            }
        },
        pincode: {
            get() {
                return this.getAddress.pincode;
            },
            set(value) {
                this.$store.commit("updateCustomerPincode", value);
            }
        },
        orderStatus: function () {
            return this.getOrderStatus === "success";
        },
        orderStatusError: function () {
            return this.getOrderStatus === "error";
        },
    },
    methods: {
        ...mapActions(["addressDetails", "orderConfirm", "addressUpdate", "getlocationDetails",]),
        confirm() {
            this.orderConfirm();
        },
        async addressFormUpdate() {
            const result = await this.v$.$validate()
            if (!result) {
                // notify user form is invalid
                console.log('enter');
                return
            }
            // perform async actions

            const addressData = {
                name: this.name,
                flat_door_no: this.flat_door_no,
                address: this.address,
                pincode: this.pincode
            };

            //console.log(addressData);
            this.addressUpdate(addressData);
        }
    }
}
</script>
